import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=0d21f41c&scoped=true"
var script = {}
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=0d21f41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21f41c",
  null
  
)

export default component.exports